"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Portal = _interopRequireDefault(require("../Portal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GridPopup = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(GridPopup, _React$PureComponent);

  var _super = _createSuper(GridPopup);

  function GridPopup() {
    var _this;

    _classCallCheck(this, GridPopup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      fields: _this.props.fields
    });

    _defineProperty(_assertThisInitialized(_this), "setWrapperRef", function (node) {
      return _this.wrapperRef = node;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var fields = _this.state.fields;
      var _event$currentTarget = event.currentTarget,
          value = _event$currentTarget.value,
          checked = _event$currentTarget.checked;

      _this.setState({
        fields: _objectSpread(_objectSpread({}, fields), {}, _defineProperty({}, value, _objectSpread(_objectSpread({}, fields[value]), {}, {
          hidden: !checked
        })))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      if (!_this.wrapperRef) return;
      if (_this.wrapperRef.contains(event.target)) return;
      var stateFields = _this.state.fields;
      var _this$props = _this.props,
          columnsMenu = _this$props.columnsMenu,
          handleSaveChanges = _this$props.handleSaveChanges,
          propsFields = _this$props.fields;
      columnsMenu.close(); // nothing changed, so no sense to call fields changes handler

      if (stateFields === propsFields) return;
      handleSaveChanges(stateFields);
    });

    _defineProperty(_assertThisInitialized(_this), "getPopup", function () {
      var _this$props2 = _this.props,
          columnsMenu = _this$props2.columnsMenu,
          t = _this$props2.t,
          gridId = _this$props2.gridId;
      var fields = _this.state.fields;
      var parent = document.getElementById(gridId);
      return columnsMenu.isOpen && /*#__PURE__*/_react["default"].createElement(_Portal["default"], {
        parent: parent
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-col-popup",
        ref: _this.setWrapperRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "check-fields"
      }, Object.entries(fields).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            value = _ref2[0],
            _ref2$ = _ref2[1],
            name = _ref2$.name,
            hidden = _ref2$.hidden,
            permanent = _ref2$.permanent;

        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "grid-hide-".concat(value)
        }, /*#__PURE__*/_react["default"].createElement("input", {
          id: "grid-hide-".concat(value),
          type: "checkbox",
          disabled: permanent,
          value: value,
          checked: !hidden,
          onChange: _this.handleChange,
          hidden: !!name
        }), name && /*#__PURE__*/_react["default"].createElement("label", {
          className: (0, _classnames["default"])('grid-col-popup-column', {
            'active': !hidden
          }),
          htmlFor: "grid-hide-".concat(value)
        }, t(name)));
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var columnsMenu = _this.props.columnsMenu;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-col-popup-wrapper"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-col-popup-button"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon-kebab-hor",
        onClick: columnsMenu.open
      })), _this.getPopup());
    });

    return _this;
  }

  _createClass(GridPopup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mousedown', this.handleClickOutside);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.fields) {
        this.setState({
          fields: nextProps.fields
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousedown', this.handleClickOutside);
    }
  }]);

  return GridPopup;
}(_react["default"].PureComponent);

exports["default"] = GridPopup;
GridPopup.propTypes = {
  t: _propTypes["default"].func.isRequired,
  columnsMenu: _propTypes["default"].object.isRequired,
  fields: _propTypes["default"].object.isRequired,
  handleSaveChanges: _propTypes["default"].func.isRequired,
  gridId: _propTypes["default"].number
};